import { EnrollmentPeriods } from './../../common-components/child-services/model/enrollment-periods.model';
import { PartyServices } from './../../service-administration/model/party-services.model';
import { ServiceReportStudentsComponent } from './service-report-students/service-report-students.component';
import { StudentServiceListsService } from './service/student-service-lists.service';
import {
    ServiceReportResult,
    ServiceReportRegion,
    ServiceReportCounty,
    ServiceReportSchoolDistrict,
    ServiceReportSchool
} from './model/service-report-result.model';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { Grade, School } from 'src/app/model/school.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { ServiceCategories } from '../../common-components/child-services/model/service-categories.model';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { ApiFetchExportDataService } from 'src/app/service/api-fetchexportdata.service';
import { Router } from '@angular/router';
import { ChildReportsService } from '../service/child-reports.service';
import { RegionDataService } from 'src/app/component/common-components/service/region-data.service';
import { CountyDataService } from 'src/app/component/common-components/service/county-data.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { DistrictDataService } from '../../common-components/service/district-data.service';
import { SchoolDataService } from '../../common-components/service/school-data.service';
import { environment } from 'src/environments/environment';
import { ServiceInfoComponent } from './service-info/service-info.component';
import { ServiceReportStudents } from './model/service-report-students.model';

@Component({
    selector: 'app-service-report',
    templateUrl: './service-report.component.html',
    styleUrls: ['./service-report.component.scss']
})
export class ServiceReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenCountyObjects: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    expiredEligibility: boolean = true;
    expiredQAD: boolean = true;
    emptyActiveServices: boolean = false;

    grades: Grade[] = [];
    partyServices: PartyServices[] = [];
    enrollmentPeriods: EnrollmentPeriods[] = [];
    serviceCategories: ServiceCategories[] = [];

    isExporting: boolean = false;
    isExportingIndividual: any = [];
    hasExports: boolean = false;

    // Component variables
    resetField: boolean = false;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstSearchServiceResponse: ServiceReportResult[];
    strExportFileName = 'Service_Report';
    strExportButtonLabel = '1 Region (2021-22)';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;
    bExportDebugMode: boolean = false;

    // Table display
    displayedColumns: string[] = [
        'SERVICE_CODE',
        'FEDERAL_CATEGORY',
        'FEDERAL_CATEGORY_CHILD',
        'SERVICE_CATEGORY',
        'PARTY_SERVICE_STATUS_TYPES_ID',
        'SERVICE_NAME',
        'MPO',
        'SSDP_COMPONENTS[0].NAME',
        'SERVICE_HOURS.NAME',
        'COUNT'
    ];

    // Table results
    tableDataSources: MatTableDataSource<ServiceReportResult>[] = [];

    // Results
    results: any[] = [];
    displayName: string = '';

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoadingResults: boolean = false;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private studentServiceListsService: StudentServiceListsService,
        private apiMsinExportsService: ApiExportsService,
        private utilityService: UtilityService
    ) {}

    ngOnInit(): void {}

    search() {
        this.ngOnInit(); // to fill all counties

        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};

            this.studentServiceListsService.getStudentServiceListCount(this.generatePayload()).subscribe({
                next: (res) => {
                    if (res.regions) {
                        this.results = res.regions.sort((n1: ServiceReportRegion, n2: ServiceReportRegion) => (n1.CODE! > n2.CODE! ? 1 : -1));

                        this.displayName = this.results.length > 1 ? 'Regions' : 'Region';
                    } else if (res.counties) {
                        this.results = res.counties.sort((n1: ServiceReportCounty, n2: ServiceReportCounty) => (n1.COUNTY_NAME! > n2.COUNTY_NAME! ? 1 : -1));

                        this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                    } else if (res.schoolDistricts) {
                        this.results = res.schoolDistricts.sort((n1: ServiceReportSchoolDistrict, n2: ServiceReportSchoolDistrict) =>
                            n1.DISTRICTS! > n2.DISTRICTS! ? 1 : -1
                        );

                        this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                    } else if (res.schools) {
                        this.results = res.schools.sort((n1: ServiceReportSchool, n2: ServiceReportSchool) => (n1.SCHOOL_NAME! > n2.SCHOOL_NAME! ? 1 : -1));

                        this.displayName = this.results.length > 1 ? 'Schools' : 'School';
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Service Report.' };
                    }
                },
                error: (err) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving Service Report.' };
                },
                complete: () => {
                    // Updates the Tables to be displayed w/ this.results
                    this.updateDataSource();

                    // Display current performance period
                    this.currentPerformancePeriod = this.selectedPerformancePeriod;

                    // Expand all
                    this.expandAll(this.results);

                    // Display results
                    this.isLoading = false;
                }
            });
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
        payload.performancePeriod = this.selectedPerformancePeriod;
        payload.bExportDebugMode = this.bExportDebugMode;
        payload.expiredEligibility = this.expiredEligibility;
        payload.expiredQAD = this.expiredQAD;
        payload.emptyActiveServices = this.emptyActiveServices;

        payload.grades = this.grades.map((obj) => obj.ID);
        payload.partyServices = this.partyServices.map((obj) => obj.ID);
        payload.enrollmentPeriods = this.enrollmentPeriods.map((obj) => obj.ID);
        payload.serviceCategories = this.serviceCategories.map((obj) => obj.ID);

        return payload;
    }

    updateDataSource() {
        this.tableDataSources = [];

        setTimeout(() => {
            this.results.forEach((result, index) => {
                // Data
                let dataSource = new MatTableDataSource<any>();
                dataSource.data = result.PARTY_SERVICE_COUNTS!;

                // Paginator
                dataSource.paginator = this.paginators.toArray()[index];

                // Sort
                dataSource.sort = this.sorts.toArray()[index];
                const defaultSort: Sort = { active: 'SERVICE_CODE', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
                dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                // Filter
                dataSource.filterPredicate = (data: any, filter) => {
                    const dataStr = JSON.stringify(data).toLowerCase();
                    return dataStr.indexOf(filter) != -1;
                };

                this.tableDataSources.push(dataSource);
            });
        });
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.selectedPerformancePeriod) {
            return true;
        }

        return false;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.expiredEligibility = true;
        this.expiredQAD = true;
        this.emptyActiveServices = false;

        this.msg = {};
    }

    expandAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = true;
        });
    }

    collapseAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = false;
        });
    }

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    announceSortChange(sortState: Sort) {}

    // Dialog Modal
    openStudentDialog(element: any, current: any) {
        let cur = JSON.parse(JSON.stringify(current));
        delete cur.PARTY_SERVICE_COUNTS;

        let payload = this.generatePayload();
        payload.ELEMENT = element;
        payload.CURRENT = cur;
        payload.GRADES = this.grades;
        payload.PARTY_SERVICES = this.partyServices;
        payload.ENROLLMENT_PERIODS = this.enrollmentPeriods;
        payload.SERVICE_CATEGORIES = this.serviceCategories;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '90vh';
        const dialogRef = this.dialog.open(ServiceReportStudentsComponent, dialogConfig);
    }

    // Filter Emiiters
    gradeEventEmitter(grades: Grade[]) {
        this.grades = grades;
    }
    serviceEventEmitter(partyServices: PartyServices[]) {
        this.partyServices = partyServices;
    }
    servicePeriodEventEmitter(enrollmentPeriods: EnrollmentPeriods[]) {
        this.enrollmentPeriods = enrollmentPeriods;
    }
    serviceCategoryEventEmitter(serviceCategories: ServiceCategories[]) {
        this.serviceCategories = serviceCategories;
    }

    openDialog(element: any) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            party_service_Id: element.PARTY_SERVICE_ID
        };

        const dialogRef = this.dialog.open(ServiceInfoComponent, dialogConfig);
    }

    downloadExcel(type: string, cur?: any, name?: string, data?: any[], index?: number) {
        this.isExporting = true;
        if (index != null) {
            this.isExportingIndividual[index] = true;
        }

        this.studentServiceListsService.getStudentsByPartyService(this.generateExportStudentsPayload(cur, data)).subscribe({
            next: (res: any) => {
                if (res.students) {
                    let students = res.students;
                    let payload = this.generateExportPayload(students, type, cur, data);

                    if (payload.data.length > 0) {
                        this.isExporting = true;
                        if (index != null) {
                            this.isExportingIndividual[index] = true;
                        }
                        this.msg = new MsgModel();

                        this.apiMsinExportsService.exportServiceReportExcel(payload).subscribe({
                            next: (res2: any) => {
                                const blob = new Blob([res2], { type: 'application/xlsx' });

                                let fileName = this.utilityService
                                    .fnMakeFileNameTime('Student_Service_List_Report_' + (name ? name + '_' : '') + this.selectedPerformancePeriod + '_' + type)
                                    .replace(/\s+/g, '_');

                                const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                                const url = URL.createObjectURL(renamedFile);

                                const a = document.createElement('a');
                                a.href = url;
                                fileName = fileName.trimLeft();

                                a.download = fileName + '.xlsx';
                                a.click();
                                if (a && a.parentNode === document.body) {
                                    document.body.removeChild(a);
                                }

                                URL.revokeObjectURL(url);
                            },
                            error: (e: any) => {
                                this.msg = { SUCCESS: false, MSG: 'Error exporting PFS Report.' };
                                this.isExporting = false;
                                if (index != null) {
                                    this.isExportingIndividual[index] = false;
                                }
                            },
                            complete: () => {
                                this.isExporting = false;
                                if (index != null) {
                                    this.isExportingIndividual[index] = false;
                                }
                            }
                        });
                    } else {
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving children for export.' };
                        this.isExporting = false;
                        if (index != null) {
                            this.isExportingIndividual[index] = false;
                        }
                    }
                } else if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving children for export.' };
                }
            },
            error: (err: any) => {
                this.msg = { SUCCESS: false, MSG: 'Error retrieving children for export.' };
                this.isExporting = false;
                if (index != null) {
                    this.isExportingIndividual[index] = false;
                }
            },
            complete: () => {}
        });
    }

    generateExportPayload(students: any, type: string, cur?: any, data?: any[]) {
        let payload: any;

        let summary = this.generateSummary(cur, data);

        if (type === 'SingleSheet') {
            payload = {
                summary: summary,
                data: this.generateStudentsServiceCodes(students, type)
            };
        } else if (type === 'SeparatedSheets') {
            payload = {
                summary: summary,
                data: this.generateStudentsServiceCodes(students, type)
            };
        }

        return payload;
    }

    generateSummary(cur?: any, data?: any[]): any {
        let summary: any;

        if (cur) {
            summary = [];

            const sum = {
                name: cur.CODE
                    ? `Region ${cur.CODE}`
                    : cur.COUNTY_CODE && cur.COUNTY_NAME
                      ? `${cur.COUNTY_CODE} - ${cur.COUNTY_NAME}`
                      : (cur.COUNTY_NAME ?? cur.DISTRICTS ?? cur.SCHOOL_NAME ?? ''),
                data
            };

            summary.push(sum);
        } else {
            summary = this.results.map((cur: any) => ({
                name: cur.CODE
                    ? `Region ${cur.CODE}`
                    : cur.COUNTY_CODE && cur.COUNTY_NAME
                      ? `${cur.COUNTY_CODE} - ${cur.COUNTY_NAME}`
                      : (cur.COUNTY_NAME ?? cur.DISTRICTS ?? cur.SCHOOL_NAME ?? ''),
                data: cur.PARTY_SERVICE_COUNTS
            }));
        }

        return summary;
    }

    generateStudentsServiceCodes(students: any, type: string) {
        if (type === 'SingleSheet') {
            return [
                {
                    name: 'Student Services',
                    data: students
                }
            ];
        }

        if (type === 'SeparatedSheets') {
            const serviceCodes = new Map<string, any[]>();

            students.forEach((student: any) => {
                const serviceCode = student.STUDENT_SERVICES?.[0]?.PARTY_SERVICES?.SERVICE_CODE;

                if (!serviceCode) {
                    return;
                }

                if (!serviceCodes.has(serviceCode)) {
                    serviceCodes.set(serviceCode, []);
                }

                serviceCodes.get(serviceCode)!.push(student);
            });

            return Array.from(serviceCodes.entries())
                .sort(([a], [b]) => Number(a) - Number(b))
                .map(([serviceCode, students]) => ({
                    name: String(serviceCode),
                    data: students
                }));
        }

        return [];
    }

    generateExportStudentsPayload(cur?: any, data?: any[]): any {
        let payload = this.generatePayload();

        if (cur) {
            if (cur.CODE) {
                payload.chosenRegions = [cur.ID];
            } else if (cur.COUNTY_NAME) {
                payload.chosenCounties = [cur.ID];
            } else if (cur.DISTRICTS) {
                payload.chosenSchoolDistricts = [cur.ID];
            } else if (cur.SCHOOL_NAME) {
                payload.chosenSchools = [cur.ID];
            }
        }

        payload.GRADES = this.grades;
        payload.PARTY_SERVICES = this.partyServices;
        payload.ENROLLMENT_PERIODS = this.enrollmentPeriods;
        payload.SERVICE_CATEGORIES = this.serviceCategories;

        return payload;
    }
}
